export default {
  name: "companymixin",
  
  //opzionale
  props:["lang"],

  data(){
    return {
           
    }
  },
  

  created(){
      //console.log("createdmixin ",this.$options.name, "lang: ",this.currentlang);  
    

  },


  computed:{
    company_name(){
        return  window.$company.name;
    },
    company_street(){
      return  window.$company.street;
    },
    company_cap(){
      return  window.$company.cap;
    },
    company_city(){
      return  window.$company.city;
    },
    company_country(){
      return  window.$company.country;
    },
    company_tel(){
      return  window.$company.tel;
    },
    company_email(){
      return  window.$company.email;
    },
    company_vat(){
      return  window.$company.vat;
    },
   
    company_mailto(){
      return "mailto:"+this.company_email;
    }

  },


  methods: {

    }
}